<ng-container
  *appHasPermission="{
    permissions: [permissions.allPermissions.DASHBOARD_READ],
  }"
>
  @if (role) {
    @if (role === "SYS_ADMIN") {
      <app-admin></app-admin>
    } @else if (role === "TENANT_ADMIN") {
      <app-tenant></app-tenant>
    } @else if (role === "CUSTOMER_ADMIN") {
      <app-customer></app-customer>
    }
  }
</ng-container>
